import React, { useState } from 'react';
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import useToggleState from 'components/hooks/useToggleState';
import ModalPopup from 'components/modal/';
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import UIDatePicker from "components/datepicker";
import codeDataStore from "common/codedata/store/CodeDataStore";
import CommonUtil from 'utils/CommonUtil';
import DateUtil from 'utils/DateUtil';
import UISelect from "components/selectbox/UISelect";

function ContentsContainer() {
	const modaladm3110 = useToggleState({});	
	const modaladm3120 = useToggleState({});	

	const initStartDate = new Date().getFullYear();
	const initEndDate = new Date().getFullYear()+5;
	
	const [yyyy,setYyyy] = useState(new Date().getFullYear());
	const [searchYyyy,setSearchYyyy] = useState(String(new Date().getFullYear()));

	const location = useLocation();
	const receivedData = (location.state as any)?.data;
	const history = useHistory();

	const [totalRowCnt,setTotalRowCnt] = useState(0);
	const [showRowCnt,setShowRowCnt] = useState(1); //기본 row count
	const [dateNum,setDateNum] = useState(2); //날짜 기본값

	/** 검색조건 */
	const [startDate,setStartDate] = useState(new Date(new Date().getFullYear()+'-01-01'));
	const [endDate,setEndDate] = useState(new Date(new Date().getFullYear()+'-12-31'));
	const [bizCd,setBizCd] = useState('');
	const [tskReqNo,setTskReqNo] = useState('');
	const [corpNm,setCorpNm] = useState('');
	const [tskNm,setTskNm] = useState('');

	const [bizNo,setBizNo] = useState('');
	const [donContDivCd,setDonContDivCd] = useState('');
	
	const [searchDivCd, setSearchDivCd] = useState('0'); // 기업명,사업자번호 , 법인번호
    const [searchText, setSearchText] = useState('');

	const [yearList, setYearList] = React.useState<any[]>([{value : new Date().getFullYear()+'', nm : new Date().getFullYear()+'년'}]);

	//초기 데이터 설정
	let totalCnt:number = 0;
	let defaultRowCnt = 20;

	const [year, setYear] = useState(new Date());
	
	let defaultYear:number = 2014; //2014년부터 조회 가능
    let start:number = new Date().getFullYear();
	let chkYear:number = 0;
	if(start > defaultYear){
		chkYear = start - defaultYear;
		start = start - chkYear;
	}

	let end = start + chkYear;
	let newYearList = [];
	for(let i = start; i <= end; i++){
		// @ts-ignore
		newYearList.push({value : i+'', nm : i+'년'})
	}
	
	

	//====== 그리드 공통 부 START
	var ib = ib||{};

	ib = {
		//시트 초기화 구문
		'init': {
			Def: {
				Row: {
					 "CanFormula": 1,
				    // "AlternateColor": "#CCDDE4"
				}
				
			},
			//공통기능 설정 부분
			"Cfg": {
				"HeaderMerge": 3,
				"SearchMode": 1,
				"FitWidth": true,
				"PrevColumnMerge": 0
			},
			//틀고정 좌측 컬럼 설정
			"LeftCols": [
				{"Header": ["No","No"],"Name": "SEQ","Width": "90"}
			],
			//중앙(메인) 컬럼 설정
			"Cols": [
				{"Header": ["사업구분","사업구분"],"Name": "BIZ_NM","MinWidth": 60,"Type": "Text","Align": "Center","CanEdit": 1},
				{"Header": ["기금사용용도","기금사용용도"],"Name": "FUN_PUR_USE_CD_NM","MinWidth": 60,"Type": "Text","Align": "Center","CanEdit": 0},
				
				{"Header": ["출연기업정보","기업명"],"Name": "CORP_NM","MinWidth": 100,"Type": "Text","Align": "Center","CanEdit": 0},
				{"Header": ["출연기업정보","기업유형"],"Name": "CORP_SIZE_CD_NM","MinWidth": 100,"Type": "Text","Align": "Center","CanEdit": 0},
				{"Header": ["출연기업정보","사업번호"],"Name": "BIZ_NO","MinWidth": 100,"Type": "Text","Align": "Center","CanEdit": 0 ,"CustomFormat": "###-##-#####"},
				{"Header": ["출연기업정보","법인번호"],"Name": "CORP_REG_NO","MinWidth": 100,"Type": "Text","Align": "Center","CanEdit": 0,"CustomFormat": "######-#######"},
				
				{"Header": ["과제구성","과제명"],"Name": "TSK_NM","MinWidth": 200,"Type": "Text","Align": "Center","CanEdit": 0,"RelWidth": 2.5},
				{"Header": ["과제구성","과제번호"],"Name": "TSK_REQ_NO","MinWidth": 100,"Type": "Text","Align": "Center","CanEdit": 0,"RelWidth": 1},
				{"Header": ["과제구성","사업년도"],"Name": "YEAR","MinWidth": 100,"Type": "Text","Align": "Center","CanEdit": 0,"RelWidth": 0.5},
				{"Header": ["과제구성","과제시작일"],"Name": "TSK_ST_DATE","MinWidth": 100,"Type": "Date","Align": "Center","CanEdit": 0 ,Format: "yyyy-MM-dd", DataFormat: "yyyy-MM-dd HH:mm:ss"},
				{"Header": ["과제구성","과제종료일"],"Name": "TSK_EN_DATE","MinWidth": 100,"Type": "Date","Align": "Center","CanEdit": 0 ,Format: "yyyy-MM-dd", DataFormat: "yyyy-MM-dd HH:mm:ss"},		
				{"Header": ["지원중소기업명","지원중소기업명"],"Name": "SUPP_CORP_NM","MinWidth": 60,"Type": "Text","Align": "Center","CanEdit": 0},
				{"Header": ["상생협력기금","상생협력기금"],"Name": "TOT_AMT","MinWidth": 60,"Type": "Int","Align": "Right","CanEdit": 0},

				{"Header": ["정부보조금(원)","1차년"],"Name": "GOV_SUB1","MinWidth": 100,"Type": "Int","Align": "Right","CanEdit": 0},
				{"Header": ["정부보조금(원)","2차년"],"Name": "GOV_SUB2","MinWidth": 100,"Type": "Int","Align": "Right","CanEdit": 0},
				{"Header": ["정부보조금(원)","3차년"],"Name": "GOV_SUB3","MinWidth": 100,"Type": "Int","Align": "Right","CanEdit": 0},
				{"Header": ["정부보조금(원)","4차년"],"Name": "GOV_SUB4","MinWidth": 100,"Type": "Int","Align": "Right","CanEdit": 0},
				{"Header": ["정부보조금(원)","5차년"],"Name": "GOV_SUB5","MinWidth": 100,"Type": "Int","Align": "Right","CanEdit": 0},
				{"Header": ["정부보조금(원)","합계"],"Name": "GOV_SUB_TOTAL","MinWidth": 100,"Type": "Int","Align": "Right","CanEdit": 0,"Formula": sumGovFormula},

				{"Header": ["중소기업 자부담금(원)","1차년"],"Name": "CORP_OWN1","MinWidth": 100,"Type": "Int","Align": "Right","CanEdit": 0},
				{"Header": ["중소기업 자부담금(원)","2차년"],"Name": "CORP_OWN2","MinWidth": 100,"Type": "Int","Align": "Right","CanEdit": 0},
				{"Header": ["중소기업 자부담금(원)","3차년"],"Name": "CORP_OWN3","MinWidth": 100,"Type": "Int","Align": "Right","CanEdit": 0},
				{"Header": ["중소기업 자부담금(원)","4차년"],"Name": "CORP_OWN4","MinWidth": 100,"Type": "Int","Align": "Right","CanEdit": 0},
				{"Header": ["중소기업 자부담금(원)","5차년"],"Name": "CORP_OWN5","MinWidth": 100,"Type": "Int","Align": "Right","CanEdit": 0},
				{"Header": ["중소기업 자부담금(원)","합계"],"Name": "CORP_OWN_TOTAL","MinWidth": 100,"Type": "Int","Align": "Right","CanEdit": 0,"Formula": sumCorpFormula},
				
			]

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {
				setYearList(newYearList);
				//setYear(new Date().getFullYear());

				//초기 데이터 로딩
				doSearch('init');
				// @ts-ignore
				sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
			},
		
			
			onBeforeDataLoad:function (evtParam) {
				// 조회 후 로딩 전 발생 이벤트
				var d = evtParam.data;
				var _data;

				let sliceData = [];
				// 서버에서 가져온 데이터를 "데이터" 텝에 넣어준다.
				if (d.length > 20) { // 최대 20개 행만 텝에 넣어 주자(많아지면 화면이 엄청 느려질 수 있음)
					sliceData = d.slice(0, defaultRowCnt);
					_data = JSON.stringify(sliceData, null, 2);
					_data += _data.substring(0, _data.length - 1) + '...\n]';
				} else {
					_data = JSON.stringify(d, null, 2);
				}
			},
			onAfterGotoPage:function (evtParam) {

				var sheet = evtParam.sheet;
				var page = sheet.getPageIndex(sheet.getFocusedPage()) + 1;
				//@ts-ignore
				if (currentPage != -1 && currentPage != page) {
					makePageIndex(page);
				}

			}
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;

			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet', // 생성할 시트의 id
				el: 'sheetDiv', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.sheet.down2Excel({fileName: "통게관리_"+today+".xlsx"});
		},
		//조회 데이터
		'data':[]
	}

	
	//정부보조금 합계 계산 
	function sumCorpFormula(fr) {
		return Number(fr.Row.CORP_OWN1) + Number(fr.Row.CORP_OWN2)+ Number(fr.Row.CORP_OWN3)+ Number(fr.Row.CORP_OWN4)+ Number(fr.Row.CORP_OWN5);
	}


	//정부보조금 합계 계산 
	function sumGovFormula(fr) {
		return Number(fr.Row.GOV_SUB1) + Number(fr.Row.GOV_SUB2)+ Number(fr.Row.GOV_SUB3)+ Number(fr.Row.GOV_SUB4)+ Number(fr.Row.GOV_SUB5);
	}

	//페이지 건수별로 보기
	const handleSelect = (e) => {
		if(e.target.name === 'showRowCnt'){
			setShowRowCnt(e.target.value);
			defaultRowCnt = e.target.value;
			// @ts-ignore
			IBSheet.disposeAll(true);
			ib.init.Cfg.PageLength = e.target.value;
			ib.create();

		}else if(e.target.name === 'searchDivCd'){
			setSearchDivCd(e.target.value);
		 }else if(e.target.name === 'year') {
			setYear(e.target.value);
		}
	};

	//====== 그리드 데이터 가지고 오기  START
	async function doSearch(sAction:string) {
		let param = {};
		//let sDt = DateUtil.toDateFormat(startDate, "YYYY-MM-DD");
		//let eDt = DateUtil.toDateFormat(endDate, "YYYY-MM-DD");
		if(sAction =='init'){
			param = {
				"YEAR" : String(new Date().getFullYear()),
			};
		}else{
			param = {
				"YEAR" : DateUtil.toDateFormat(year, "YYYY") ,
				"BIZ_CD" : bizCd,
				"TSK_NM" : tskNm,
				"TSK_REQ_NO" : tskReqNo
			//	"SEARCH_DIV_CD" : searchDivCd,
			//	"SEARCH_TEXT":searchText
			};
		}


		//파라미터 전송
		const response:any = await CommonUtil.execute({
			url:'usr_2209',
			data: param
		})

		//전체데이터
		let result = response.LIST;

		if(result !=null && result.length > 0){
			//전체ROW개수
			totalCnt = Object.keys(result).length;
			setTotalRowCnt(Object.keys(result).length);
		}

		//데이터 처리
		ib.data = result;

		// @ts-ignore
		sheet.loadSearchData(result);  //data 로딩 처리
		// @ts-ignore
		sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
		// @ts-ignore
		makePageIndex(sheet.getPageIndex( sheet.getFocusedPage()) + 1); // 페이지 초기화

	}

	//====== 그리드 데이터 가지고 오기  END

	//====== 그리드 페이징 처리
	// @ts-ignore
	const makePageIndex = function (tp:number) {
		try {
			if (tp == null) {
				//@ts-ignore
				currentPage = -1;
				return;
			}

			// @ts-ignore
			if (document.getElementById('pageNavi').firstChild) {
				// @ts-ignore
				document.getElementById('pageNavi').removeChild(document.getElementById('pageNavi').firstChild);
			}

			// @ts-ignore
			currentPage = tp;
			// @ts-ignore
			let sr = totalCnt // 전체 조회 건수
			// @ts-ignore
			let page = defaultRowCnt; // 페이지당 레코드 수
			let thispage = tp; // 현재 페이지
			let pagecnt = 5; // 한번에 표시할 페이지 개수
			let lastpage = Math.ceil(sr / page); // 마지막 페이지 인덱스
			let li, tt, a;
			let ul = document.createElement('DIV');
			// @ts-ignore
			ul.style.textAlign = 'center';

			let k = 1;

			if (thispage !== 1) {
				let ul_sub = document.createElement('DIV');
				ul_sub.className ="group";
				li = document.createElement('Button');
				li.className = 'item first';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				tt = document.createTextNode('<<');
				addEventHandler(li, 'click', pageMove, 1);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);

				li = document.createElement('Button');
				li.className = 'item prev';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				addEventHandler(li, 'click', pageMove, tp - 1);
				tt = document.createTextNode('<');
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);
			}

			sr = (Math.ceil(tp / pagecnt) * pagecnt) - (pagecnt - 1);
			let ul_sub2 = document.createElement('DIV');
			ul_sub2.className ="group";
			for (let i = sr; i < (sr + pagecnt); i++) {
				if (i <= lastpage) {
					li = document.createElement('Button');
					li.className ="item";
					a = document.createElement('a');
					a.style.cursor = 'pointer';
					tt = document.createTextNode(String(i));
					addEventHandler(li, 'click', pageMove, i);
					if (i === tp) {
						li.className ="item active";
					}
					a.appendChild(tt);
					li.appendChild(a);
					ul_sub2.appendChild(li);
					ul.appendChild(ul_sub2);
				}
			}

			if (thispage < lastpage) {
				let ul_sub3 = document.createElement('DIV');
				ul_sub3.className ="group";
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				li = document.createElement('Button');
				li.className = 'item next';
				tt = document.createTextNode('>');
				addEventHandler(li, 'click', pageMove, tp + 1);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);

				li = document.createElement('Button');
				li.className = 'item last';
				tt = document.createTextNode('>>');
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				addEventHandler(li, 'click', pageMove, lastpage);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);
			}

			ul.className = 'pg';
			// @ts-ignore
			document.getElementById('pageNavi').appendChild(ul);
		} catch (ex) {
			// @ts-ignore
			alert(ex.message);
		}
	}

	//페이지 이동
	// @ts-ignore
	const pageMove = function (cPage:number) {
		// @ts-ignore
		sheet.goToPageByIndex(cPage);

	}

	//페이지 이동 이벤트 핸들러
	// @ts-ignore
	const addEventHandler = function (obj, evtName, func, param) {
		if (obj.addEventListener) { // all browsers except IE before version 9
			obj.addEventListener(evtName, function () { func(param); }, false);
		} else if (obj.attachEvent) { // IE before version 9
			obj.attachEvent('on' + evtName, function () { func(param); });
		}
	}

	 //인풋 엔터체크
	 const activeEnter = (e) => {
        if(e.key === "Enter") {
            doSearch("search");
        }
    }


	// init
	React.useEffect(() => {

		//필요한 공통코드 로딩.
		codeDataStore.read("cfms.portalBizCdList").then(() => {
			//ib시트 생성
			ib.create();
			
		});


		return () => {
			// @ts-ignore
			IBSheet.disposeAll(true);
		}
	},[])

	return (
		<PageContainer>
			<LayoutAside />
				<div className="fww-con">

					<ul className="fww-brd">
						<li className=""><a href="">홈</a></li>
						<li className=""><a href="">관리자페이지</a></li>
						<li className=""><a href="">공시/발급</a></li>
						<li className=""><a href="">법인세공시</a></li>
					</ul>

					<main className="fww-main">
						<h1 className="tx tx-hd2">통계관리</h1>

						<div className="sf  sf-2col">
							<div className="inner">
								<div className="sf-item">
								<p className="sf-key">사업년도</p>
									<div className="sf-value">
									<div className="w320">
											<UIDatePicker
												value={year}
												valueChanged={(value) => {setYear(value);}}
												displayFormat={'YYYY'}
												dateFormat={'YYYY'}
											/>
										</div>
									</div>
								</div>
								
								{/* <div className="sf-item">
								<p className="sf-key">사업년도</p>
									<div className="sf-value">
										<div className="sl sl-md w100p">
											<select name="year" id="year" value={year} onChange={(handleSelect)}>
												<option value="">전체</option>
												{yearList.map((year, idx) => (
													<option value={year.value}>{year.nm}</option>
												))}
											</select>
										</div>

									</div>
								</div> */}
								
								<div className="sf-item">
									<p className="sf-key">사업명</p>
									<div className="sf-value">
									<div className="sl sl-md w100p">
										<UISelect
											value={bizCd}
											valueChanged={(value) => setBizCd(String(value))}
											codeData={codeDataStore.get("cfms.portalBizCdList")}
											firstName={"all"}
										/>
										</div>
									</div>
								</div>
								
								<div className="sf-item">
									<p className="sf-key">과제명</p>
									<div className="sf-value">
										<UIInput className={'tf tf-md w100p'} value={tskNm}	valueChanged={(value) => setTskNm(value)} onKeyEnter={(e) => activeEnter(e)}/>
									</div>
								</div>

								<div className="sf-item">
									<p className="sf-key">과제번호</p>
									<div className="sf-value">
										<UIInput className={'tf tf-md w100p'} value={tskReqNo}	valueChanged={(value) => setTskReqNo(value)} onKeyEnter={(e) => activeEnter(e)}/>
									</div>
								</div>


								{/* <div className="sf-item">
									<p className="sf-key">조회구분</p>
									<div className="sf-value">
										<div className="hz-root hz-gap8">
											<div className="hz-item sl sl-md w120">
											<select name="searchDivCd" id="searchDivCd" value={searchDivCd} onChange={handleSelect}>
												<option value='0'>선택</option>
												<option value='1'>기업명</option>
												<option value='2'>사업자번호</option>
												<option value='3'>법인번호</option>
											</select>
											</div>
											<UIInput className={'hz-item hz-fg tf tf-md'} placeholder={'검색어를 입력하세요'} value={searchText} valueChanged={(value) => setSearchText(value)} onKeyEnter={(e) => activeEnter(e)}/>
										</div>
										
									</div>
								</div>																	 */}
							</div>
						</div>
						<div className="hz-root hz-center mb30">
							<button className="bt" data-color="pri" data-size="md" type="button"onClick={()=>doSearch('search')}>조회</button>
						</div>

						<div className="tb-top">
							<div>
								<p className="tx fc-black"></p>총 <em className="fw500">{totalRowCnt}</em>건
							</div>
							<div className="hz-root hz-gap5">
								<Button color="gray-o" size="sm" onClick={() => ib.exportData()}>다운로드</Button>
							
								<div className="sl sl-sm w120">
									<select name="showRowCnt" id="showRowCnt" className=""  onChange={(handleSelect)}>
										<option value="20">20개씩보기</option>
										<option value="50">50개씩보기</option>
										<option value="100">100개씩보기</option>
										<option value="200">200개씩보기</option>
										<option value="500">500개씩보기</option>
										<option value="1000">1000개씩보기</option>
									</select>
								</div>
							</div>
						</div>
						<div id='sheetDiv'>[D] IBSHEET 영역</div>
						<div id="pageNavi" className="pg"></div>

					</main>

				</div>
				

		</PageContainer>
	);
}
export default ContentsContainer;